import { render, staticRenderFns } from "./filter-selector.vue?vue&type=template&id=710c7080&"
import script from "./filter-selector.vue?vue&type=script&lang=js&"
export * from "./filter-selector.vue?vue&type=script&lang=js&"
import style0 from "./filter-selector.vue?vue&type=style&index=0&id=710c7080&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports